<tg-row>
    <tg-col>
        <div class="property-ui__grid-content property-ui__grid-content--ruled">
            <property-information-section></property-information-section>
        </div>
    </tg-col>
    <tg-col>
        <div
            class="
                property-ui__grid-content property-ui__grid-content--ruled
                property-information-page__container--large-margin
            "
        >
            <property-features-section></property-features-section>
        </div>
    </tg-col>
    <tg-col>
        <div
            class="property-ui__grid-content property-ui__grid-content--ruled property-information-page__container--large-margin"
        >
            <property-parking-section></property-parking-section>
        </div>
    </tg-col>
    <tg-col>
        <div
            class="
                property-ui__grid-content property-ui__grid-content--ruled
                property-information-page__container--large-margin
            "
        >
            <property-sale-details-section></property-sale-details-section>
        </div>
    </tg-col>
    <tg-col>
        <div
            class="
                property-ui__grid-content property-ui__grid-content--ruled
                property-information-page__container--large-margin
            "
        >
            <property-open-home-times-section></property-open-home-times-section>
        </div>
    </tg-col>
    <tg-col>
        <div
            class="
                property-ui__grid-content
                property-information-page__container--large-margin
                property-information-page__container--no-padding-bottom
            "
        >
            <property-contact-details-section></property-contact-details-section>
        </div>
    </tg-col>
</tg-row>
